import { cn } from "../../../helpers";
import styles from "./Card.module.scss";

export interface CardProps {
    children: React.ReactNode;
    classNames?: string;
}

export function Card({ children, classNames }: CardProps) {
    return <article className={cn(styles.card, classNames)}>{children}</article>;
}
